import { addressSchema } from './address.schema';

export default {
  type: 'object',
  properties: {
    data: {
      properties: {
        contractor: {
          type: 'object',
          properties: {
            displayName: {
              fieldRequired: true,
              type: 'string',
              title: 'Imię i nazwisko / nazwa pracodawcy'
            },

            nip: {
              fieldRequired: true,
              type: 'string',
              title: 'Numer NIP'
            },

            bankAccount: {
              description: 'W przypadku autowypłaty należy pozostawić pole puste',
              fieldRequired: false,
              format: 'iban',
              title: 'Numer rachunku bankowego',
              type: 'string'
            },

            address: addressSchema
          }
        }
      },
      type: 'object'
    },

    id: { type: 'number' },

    packId: {
      type: 'number',
      title: 'Id paczki'
    }
  }
};
